module.exports = __webpack_public_path__ + "img/Lbus03_R_home slider.deef1885.jpg";